module.exports = __webpack_public_path__ + "static/moddoc2-c96c96023c3a182f0dd73acda6fa8109.gif";